export const formatPartStatus = (status) => {
  if (status === null || status === undefined) {
    return status;
  }
  if (typeof status === "number") {
    return status.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
  if (typeof status !== "string") {
    return status;
  }

  const trimmed = status.trimStart();
  const match = trimmed.match(/^(-?[\d,]+(?:\.\d+)?)(.*)$/);
  if (!match) {
    return status;
  }

  const numericValue = Number(match[1].replace(/,/g, ""));
  if (Number.isNaN(numericValue)) {
    return status;
  }

  const formattedNumber = numericValue.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  const leadingWhitespace = status.slice(0, status.length - trimmed.length);

  return `${leadingWhitespace}${formattedNumber}${match[2]}`;
};
